import parseIntFromStr from '../parseIntFromStr';

export default function descSort(firstValue, secondValue) {
    return parseIntFromStr(secondValue) > parseIntFromStr(firstValue);
}